import React, { Component } from "react";
import { connect } from "react-redux";

import LocaleStrings from "../../../../../languages/index";
import { Fragment } from "react";
import { Menu, Transition } from "@headlessui/react";
import { DotsVerticalIcon } from "@heroicons/react/solid";
import {
  BASE_IMAGES_URL,
  APP_API_KEY,
} from "../../../../../../common/constants";
import { confirmAlert } from "react-confirm-alert";
import { deleteWatchlistitems, fetchWatchlist } from "../../../actions/index";
import _ from "lodash";
import { updateMRP } from "../../../../../../common/common-functions";
import { ProductTextLocalized } from "../../../../../../common/common-functions";
import AllitemProductdetailmodal from "../../../../sellermanagement/components/tabs/product/allitems-productdetails";
import { NotificationManager } from "react-notifications";
import {
  currencyCode,
  currencyRate,
  isCurrencyRateApplicable,
} from "../../../../currency/action/index";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

class Watchlistproducts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      setOpen: false,
    };
  }

  _handleDelete(e, values, data) {
    confirmAlert({
      title: "Delete WatchList",
      message: `${LocaleStrings.delete_confirmation_suheader_text}`,
      buttons: [
        {
          label: LocaleStrings.button_yes,
          onClick: () => {
            this.props.deleteWatchlistitems(
              this.props.session,
              values,
              data,
              (resource) => {
                // console.log("showresource :- ", resource);
                if (resource.success == 0) {
                  NotificationManager.error("Error in deleting");
                } else {
                  NotificationManager.success("Successfully Deleted");
                  this.props.fetchWatchlist(
                    this.props.session,
                    this.props.data.userid,
                    1,
                    (CallBackResponse) => {}
                  );
                }
              }
            );
          },
        },
        {
          label: LocaleStrings.button_no,
          onClick: () => {},
        },
      ],
    });
  }
  openModal = (e) => this.setState({ isOpen: true });
  closeModal = () => this.setState({ isOpen: false });

  render() {
    var { values, data, language, localCurrency } = this.props;

    let all_variants = values.product.all_variants;
    // console.log('all_variants',all_variants)
    let price = _.filter(all_variants, function (o) {
      return o.id == values.product.variantid;
    });
    // console.log('price',price)

    let itemPrice = price.length > 0 ? price[0].price_unit : 0;
    // console.log('itemPrice',itemPrice)
    let priceObj = updateMRP(values, values.product.variantid);
    let discountedPrice = priceObj.discountedPrice;
    let strProductDiscount = priceObj.strProductDiscount;

    let currency = currencyCode(localCurrency);

    let productCurrency = "QAR";
    if (values.currency && (values.currency != "" || values.currency != null)) {
      productCurrency = values.currency;
    }

    let itemPrice_val = isCurrencyRateApplicable(
      values.product.currency,
      itemPrice
    );
    let discountedPrice_val = discountedPrice;

    var img = `${BASE_IMAGES_URL}/vendor/variations/${values.product.productimage}?api_key=${APP_API_KEY}`;

    return (
      <>
        <div className="flex flex-col rounded-lg shadow-lg overflow-hidden cursor-pointer">
          <div className="flex-shrink-0 relative">
            <img className="h-60 w-full object-cover " src={img} alt="" />
            {/* <StarIcon className="h-5 w-5 absolute top-1 left-1" aria-hidden="true" /> */}

            <div className="absolute top-1 right-1">
              <Menu as="div" className="relative inline-block text-left">
                {({ open }) => (
                  <>
                    <div>
                      <Menu.Button className="bg-quaternary rounded-full flex items-center text-gray-400 hover:text-secondary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-primary">
                        <span className="sr-only">Open options</span>
                        <DotsVerticalIcon
                          className="h-5 w-5"
                          aria-hidden="true"
                        />
                      </Menu.Button>
                    </div>

                    <Transition
                      show={open}
                      as={Fragment}
                      enter="transition ease-out duration-100"
                      enterFrom="transform opacity-0 scale-95"
                      enterTo="transform opacity-100 scale-100"
                      leave="transition ease-in duration-75"
                      leaveFrom="transform opacity-100 scale-100"
                      leaveTo="transform opacity-0 scale-95">
                      <Menu.Items
                        static
                        className="origin-top-right absolute right-0 mt-2 w-36 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
                        <div className="py-1">
                          <Menu.Item>
                            {({ active }) => (
                              <div
                                className={classNames(
                                  active
                                    ? "bg-quaternary text-secondary"
                                    : "text-secondary",
                                  "block px-3 py-2 text-sm"
                                )}
                                onClick={(e) =>
                                  this._handleDelete(e, values, data)
                                }>
                                {LocaleStrings.removefromwatchlist}
                              </div>
                            )}
                          </Menu.Item>
                        </div>
                      </Menu.Items>
                    </Transition>
                  </>
                )}
              </Menu>
            </div>
          </div>
          <div
            className="flex-1 bg-white p-2 flex flex-col justify-between"
            onClick={(e) => this.openModal(e, values.product)}>
            <div className="flex-1">
              <span className="block mt-2">
                <p className="text-xs font-semibold text-secondary">
                  {ProductTextLocalized(
                    values.product.productname_en,
                    values.product.productname_ar,
                    language
                  )}
                </p>
                <p className="mt-1 text-xs text-ternary">
                  {ProductTextLocalized(
                    values.product.product_desc_en.length > 80
                      ? values.product.product_desc_en.substring(1, 60) + "..."
                      : values.product.product_desc_en,
                    values.product.product_desc_ar.length > 80
                      ? values.product.product_desc_ar.substring(1, 60) + "..."
                      : values.product.product_desc_ar,
                    language
                  )}
                </p>
              </span>
            </div>
          </div>
          <div
            className="grid grid-cols-3 gap-4 mb-2 p-2"
            onClick={(e) => this.openModal(e, values.product)}>
            <div>
              <p className="text-xs font-semibold text-secondary">
                {currency}
                {itemPrice_val}
              </p>
            </div>
            <div>
              <p className="text-xs line-through ...">
                {" "}
                {currency} {discountedPrice_val}
              </p>
            </div>
            <div>
              <p className="text-xs text-danger">
                {values.product.saletype == "auction" ? (
                  <div>{values.product.numbids}Bids</div>
                ) : (
                  ""
                )}
              </p>
            </div>
          </div>
        </div>
        {this.state.isOpen ? (
          <AllitemProductdetailmodal
            isOpen={this.state.isOpen}
            onClose={this.closeModal}
            productDetails={this.props.values.product}
            qa={this.props.values.product.qa}
          />
        ) : (
          ""
        )}
      </>
    );
  }
}

var mapStateToProps = (state) => ({
  isLoggedIn: state.isLoggedIn,
  user: state.user,
  session: state.session,
  localCurrency: state.currency,
});

export default connect(mapStateToProps, {
  deleteWatchlistitems,
  fetchWatchlist,
  isCurrencyRateApplicable,
})(Watchlistproducts);
